import Sort from "../../../assets/img/admin/sort.png";

const RecentMembersTable = ({ members }) => {
  if (!members) {
    return (
      <div className="px-4 mt-8">
        <h2 className="text-lg font-semibold text-black mb-2">
          Recent Members
        </h2>
        <div className="bg-white rounded-xl shadow-sm overflow-x-auto animate-pulse">
          <div className="h-64 bg-gray-300 rounded-xl"></div>
        </div>
      </div>
    );
  }

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "bg-green";
      case "rejected":
        return "bg-red";
      case "pending":
        return "bg-yellow-400";
      default:
        return "bg-gray-500";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    // Convert DD/MM/YYYY to readable format
    const [day, month, year] = dateString.split("/");
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className="px-4 mt-8">
      <h2 className="text-lg font-semibold text-black mb-2">Recent Members</h2>
      <div className="bg-white rounded-xl shadow-sm overflow-x-auto">
        <table className="min-w-full table-fixed text-sm border border-gray-300 border-t-0">
          <thead className="bg-[#4F22D8] text-white text-base">
            <tr>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-16">
                <button className="flex items-center gap-2">
                  No
                  <img
                    src={Sort}
                    alt="sort"
                    className="w-4 h-4 object-contain"
                  />
                </button>
              </th>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-[200px]">
                Name
              </th>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-[150px]">
                Membership ID
              </th>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-[120px]">
                <div className="flex items-center gap-2">
                  Created Date
                  <img
                    src={Sort}
                    alt="sort"
                    className="w-4 h-4 object-contain"
                  />
                </div>
              </th>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-[150px]">
                Membership Type
              </th>
              <th className="py-3 px-4 text-left font-bold border-r border-gray-400 w-[100px]">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            {members.length === 0 ? (
              <tr>
                <td colSpan="6" className="px-4 py-8 text-center text-gray-500">
                  No recent members found
                </td>
              </tr>
            ) : (
              members.map((member, idx) => (
                <tr
                  onClick={() => {
                    const title = encodeURIComponent(
                      member.name.replace(/\s+/g, "-")
                    );
                    window.location.href = `/admin/members/detail/${member._id}/${title}?from=dashboard`;
                  }}
                  key={member.membershipId || idx}
                  className="border-t cursor-pointer border-gray-300 text-[15px] hover:bg-gray-50 transition-colors"
                >
                  <td className="px-4 py-3 pl-7 text-black border-r border-gray-300 text-center">
                    {member.no || idx + 1}
                  </td>
                  <td className="px-4 py-3 text-black border-r border-gray-300 font-medium">
                    {member.name || "N/A"}
                  </td>
                  <td className="px-4 py-3 text-black border-r border-gray-300">
                    {member.membershipId || "N/A"}
                  </td>
                  <td className="px-4 py-3 text-black border-r border-gray-300">
                    {formatDate(member.createdDate)}
                  </td>
                  <td className="px-4 py-3 text-black border-r border-gray-300">
                    {member.membershipType || "N/A"}
                  </td>
                  <td className="px-4 py-3 border-r border-gray-300">
                    <span
                      className={`text-white ${getStatusColor(
                        member.status
                      )} text-xs px-3 py-[6px] rounded-full font-medium capitalize`}
                    >
                      {member.status || "Unknown"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentMembersTable;
